import {
  Button,
  ButtonColor,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import clsx from 'clsx';
import React, { FC } from 'react';
import { PatientPanelHeader } from './PatientPanelHeader';

import styles from './EmptyBlock.module.scss';

export interface Props {
  title?: string;
  text: string;
  buttonTitle?: string;
  onClick?: () => void;
  className?: string;
}

export const EmptyBlock: FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <div
      className={clsx(styles.mainContainer, props.className)}
      data-test-id={'empty-block'}
    >
      {props.title && <PatientPanelHeader title={props.title} />}
      <div className={styles.container}>
        <div className={styles.text}>{props.text}</div>
        {props.onClick && props.buttonTitle && (
          <Button
            title={props.buttonTitle}
            onClick={props.onClick}
            color={ButtonColor.Primary}
            className={styles.button}
          />
        )}
      </div>
      {props.children}
    </div>
  );
};
